// extracted by mini-css-extract-plugin
module.exports = {"circle":"coloredCircle_circle__3SXmJ"};